module.exports = __webpack_public_path__ + "static/media/appStore.53dfd1c1.png";